module.exports = __webpack_public_path__ + "images/8eae1b13669b453e06a3edcd02931eeb-PNG-LHW-Logo-Dark-Slate-2379C.png";